/* ============================================================
   Smartlet - Reviews CTA button handler
   Asset version v4.1

   v4.1 - Chain: open the Station Tabs "reviews" tab, then open the
     Judge.me write-review modal.
     v4.0 opened the reviews tab and stopped there. v4.1 goes one
     step further and also triggers the native Judge.me write-review
     button, so the verified review button takes the user all the
     way to the review form.

     How the native form is opened:
       The Judge.me widget on this shop is the newer "jm-" version.
       Its write-review button carries data-testid="write-review-
       button". Clicking that element makes Judge.me open its own
       modal with its own code, correctly initialised. We do not
       call Judge.me internal methods (jdgm.openForm and friends
       throw when called out of context) and we do not poke the
       modal's display style by hand. We click the real button, the
       way a user would.

     Timing safeguard:
       The native button is inside the Station Tabs panel, which is
       only populated once the tab opens, and Judge.me itself can
       briefly be in a state where opening the modal throws
       (observed in production: "Cannot read properties of undefined
       (reading 'urlParam')"). So v4.1 does NOT use a single fixed
       delay. After opening the tab it polls for the native button
       on short stepped intervals (waitFor). It clicks the button
       only once it is actually present. If the button never shows
       up within the budget, it stops cleanly: the user is at worst
       left on the open reviews tab, which is the v4.0 result, never
       a broken state.

   ---- earlier history ----
   v4.0 found the real cause: the reviews live in a closed Station
     Tabs Pro tab. The button must open that tab, not scroll. Proven
     in production: clicking [data-slug="reviews"] opens the tab.
   v2.5 - v3.3: a long series of scroll-based attempts, all
     superseded once the closed-tab cause was identified.

   Mechanism summary:
     - Delegated click listener on document, matched with closest()
       on .js-reviews-scroll.
     - Step 1: click the Station Tabs tab [data-slug="reviews"].
     - Step 2: waitFor [data-testid="write-review-button"], then
       click it to open the Judge.me modal.
     - Guard flag so the listener is bound only once.

   Note: this handler does NOT touch the URL hash. Adding
   #judgeme_product_reviews to the URL at load time caused a blank
   page on some product pages, so the hash is left out entirely.
   ============================================================ */
(function () {
  if (window.smartletReviewsTabBound) return;
  window.smartletReviewsTabBound = true;

  /* ---- Step 1: open the Station Tabs Pro "reviews" tab ---- */
  function openReviewsTab() {
    var tab = document.querySelector('.station-tabs-tab[data-slug="reviews"]')
           || document.querySelector('[data-slug="reviews"][role="tab"]')
           || document.querySelector('[data-slug="reviews"]');
    if (!tab) return false;
    tab.click();
    return true;
  }

  /* ---- Step 2: open the Judge.me native write-review modal ---- */
  function clickWriteReviewButton() {
    var btn = document.querySelector('[data-testid="write-review-button"]');
    if (!btn) return false;
    btn.click();
    return true;
  }

  /* Poll for an element produced by fn, on stepped intervals, up to
     a total budget. Calls onFound once it appears. Stops silently if
     it never does - never throws, never leaves a broken state. */
  function waitFor(fn, onFound) {
    var attempts = 0;
    var maxAttempts = 12;   /* 12 x 150ms = 1.8s total budget */
    var stepMs = 150;
    if (fn()) { onFound(); return; }
    var timer = setInterval(function () {
      attempts++;
      if (fn()) {
        clearInterval(timer);
        onFound();
      } else if (attempts >= maxAttempts) {
        clearInterval(timer);
        /* Give up cleanly. The reviews tab is open (v4.0 result),
           the user can click the native button themselves. */
      }
    }, stepMs);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.js-reviews-scroll');
    if (!trigger) return;
    e.preventDefault();

    /* Step 1: open the reviews tab. */
    openReviewsTab();

    /* Step 2: once the native Judge.me write-review button is
       actually in the DOM, click it to open the modal. */
    waitFor(
      function () { return document.querySelector('[data-testid="write-review-button"]'); },
      function () { clickWriteReviewButton(); }
    );
  });


  /* ---- Deep-link to the reviews tab: URL has #reviews (or ?view=reviews / ?reviews=1) ----
     Station Tabs Pro native deepLinks are OFF, so we open the tab ourselves.
     Fires across every navigation style (full load, bfcache, hash change, history) so it
     survives instant-page / Shoplift-preview navigation, not just a cold page load. */
  function reviewsDeepLinkRequested(){
    return /[?&](view=reviews|reviews=1)/.test(location.search) || /(^|#)reviews$/i.test(location.hash);
  }
  var _reviewsRunning = false, _reviewsDone = false;
  function openReviewsFromUrl(){
    if(!reviewsDeepLinkRequested()) return;
    if(_reviewsRunning || _reviewsDone) return;
    _reviewsRunning = true;
    var tries = 0, max = 60; /* ~12s budget for slow tab init */
    var t = setInterval(function(){
      tries++;
      var tab = document.querySelector('.station-tabs-tab[data-slug="reviews"]')
             || document.querySelector('[data-slug="reviews"][role="tab"]')
             || document.querySelector('[data-slug="reviews"]');
      if(tab){
        clearInterval(t);
        openReviewsTab();
        var st = 0, smax = 40;
        var s = setInterval(function(){
          st++;
          var tb = document.querySelector('[data-slug="reviews"]');
          var pid = tb && (tb.getAttribute('aria-controls') || tb.getAttribute('data-target'));
          var panel = pid ? document.getElementById(pid) : null;
          var target = panel || tb || tab;
          var ready = (panel && panel.getBoundingClientRect().height > 40) || st > 12;
          if(ready){
            clearInterval(s);
            _reviewsRunning = false; _reviewsDone = true;
            if(target && target.scrollIntoView){
              target.scrollIntoView({behavior:'smooth', block:'start'});
              setTimeout(function(){ if(target.scrollIntoView){ target.scrollIntoView({behavior:'auto', block:'start'}); } }, 700);
            }
          } else if(st >= smax){ clearInterval(s); _reviewsRunning = false; }
        }, 250);
      } else if(tries >= max){ clearInterval(t); _reviewsRunning = false; }
    }, 200);
  }
  /* Re-arm on a genuine new navigation (so back/forward or a fresh click re-runs it). */
  function armReviewsDeepLink(){ _reviewsDone = false; openReviewsFromUrl(); }
  if(document.readyState !== 'loading'){ openReviewsFromUrl(); }
  document.addEventListener('DOMContentLoaded', openReviewsFromUrl);
  window.addEventListener('load', openReviewsFromUrl);
  window.addEventListener('pageshow', armReviewsDeepLink);      /* bfcache restore */
  window.addEventListener('hashchange', armReviewsDeepLink);    /* #reviews set via SPA/instant nav */
  window.addEventListener('popstate', armReviewsDeepLink);      /* history back/forward */
  document.addEventListener('shopify:section:load', openReviewsFromUrl);

})();
